<p-dialog
        [header]="'Are you sure you want to delete current image?'"
        [modal]="true"
        (onHide)="close()"
        [(visible)]="dialogVisible"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [draggable]="false"
        [resizable]="false"
        [dismissableMask]="true"
>
    <div class="flex justify-content-end gap-2">
        <p-button
                label="Cancel"
                (click)="close()"
                severity="secondary"/>
        <p-button
                [loading]="loading"
                label="Yes"
                (click)="delete()"/>
    </div>
</p-dialog>